var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('div',{staticClass:"text-center mt-3"},[(!_vm.loading)?_c('router-link',{staticClass:"btn btn-link p-0",attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t('components.utility.turn_back'))+" ")]):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }